export const getHasJWT = (): boolean => !!sessionStorage.getItem("auth_token");
export const getJWT = (): string | null => sessionStorage.getItem("auth_token");
export const setJWT = (authToken: string): void =>
  sessionStorage.setItem("auth_token", authToken);

export const getHasRefreshToken = (): boolean =>
  !!sessionStorage.getItem("refresh_token");
export const getRefreshToken = (): string | null =>
  sessionStorage.getItem("refresh_token");
export const setRefreshToken = (refreshToken: string): void =>
  sessionStorage.setItem("refresh_token", refreshToken);
